import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import { theme } from "@/theme";

export default function StatusCard({ isSuccessful, status, updatesNumber }) {
    const IconComponent = isSuccessful ? CheckCircleIcon : CancelIcon;
    const backgroundColor = isSuccessful ? theme.palette.success.secondary : theme.palette.error.secondary;

    return (
        <Box
            sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                gap: 2,
                justifyContent: "center",
                minWidth: 150,
                bgcolor: backgroundColor,
                borderRadius: 2,
                mx: 2,
                p: 3,
                textAlign: "center",
            }}
        >
            <IconComponent
                sx={{
                    color: isSuccessful ? theme.palette.success.main : theme.palette.error.main,
                    fontSize: 24,
                }}
            />
            <Typography
                variant="body1"
                sx={{
                    color: theme.palette.common.black,
                    fontWeight: 400,
                }}
            >
                {status}
            </Typography>
            <Typography
                variant="h5"
                sx={{
                    color: theme.palette.common.black,
                    fontWeight: 700,
                }}
            >
                {updatesNumber}
            </Typography>
        </Box>
    );
}

StatusCard.propTypes = {
    isSuccessful: PropTypes.bool,
    status: PropTypes.string,
    updatesNumber: PropTypes.number,
};
